import { IsNotEmpty, IsUUID, IsInt, IsOptional, Min } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Type } from 'class-transformer'

export class CreateActivityLessonLinkDto {
  @ApiProperty({
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty()
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: 'UUID de la leçon',
    example: '660e8400-e29b-41d4-a716-446655440001',
  })
  @IsNotEmpty()
  @IsUUID('4')
  lessonId!: string

  @ApiProperty({
    description: "UUID de l'utilisateur qui ajoute le lien",
    example: '770e8400-e29b-41d4-a716-446655440002',
  })
  @IsNotEmpty()
  @IsUUID('4')
  addedByUserId!: string

  @ApiPropertyOptional({
    description: "Ordre de l'activité dans la leçon",
    example: 1,
    minimum: 0,
  })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(0)
  orderInLesson?: number
}
